import React, { useState } from "react";
// Import Material-UI components for layout, navigation, and animations
import {
  Box,
  Typography,
  IconButton,
  Avatar,
  Fade,
  useTheme,
  useMediaQuery,
} from "@mui/material";
// Import icons for navigation and quote
import { ArrowBack, ArrowForward, FormatQuote } from "@mui/icons-material";
import "./Testimonial.css";
// Import website configuration for images
import { websiteImages } from "../../../config/config";

// Array of testimonial data
const testimonials = [
  {
    id: 1,
    text: "Work is exceptional, and it's clear that you put a great deal of effort and thought into every aspect of it. Attention to detail is remarkable, and it sets a high standard for the rest of the team is impressive.",
    name: "Stefanie Rashford",
    avatar:
      "https://media.istockphoto.com/id/1135381120/photo/portrait-of-a-young-woman-outdoors-smiling.jpg?s=612x612&w=0&k=20&c=T5dukPD1r-o0BFqeqlIap7xzw07icucetwKaEC2Ms5M=",
  },
  {
    id: 2,
    text: "Outstanding quality and professionalism. The team delivered beyond our expectations and maintained excellent communication throughout the project. Highly recommended!",
    name: "Michael Chen",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
  },
  {
    id: 3,
    text: "Incredible attention to detail and creative solutions. The final result exceeded our vision and helped transform our business approach completely.",
    name: "Sarah Williams",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
  },
];

// Define the Testimonial component
const Testimonial = () => {
  // State to manage the current testimonial index
  const [currentIndex, setCurrentIndex] = useState(0);
  // Hook to access the current theme
  const theme = useTheme();
  // Hook to check if the screen is mobile-sized
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Handle navigation to the previous testimonial
  const handlePrevious = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  // Handle navigation to the next testimonial
  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  // Get the current testimonial based on index
  const currentTestimonial = testimonials[currentIndex];

  return (
    // Main container for the testimonial section
    <div
      className="section-08"
      style={{ position: "relative" }}
    >
      {/* Background corner overlay image */}
      <img
        src={websiteImages.vectorReviewImage}
        alt="corner-overlay"
        className="corner-overlay-review"
      />

      <Box className="testimonial">
        <div maxWidth="lg" className="testimonial-container container">
          {/* Testimonial header */}
          <Box className="testimonial-header">
            <Typography variant="overline" className="testimonial-subtitle">
              TESTIMONIALS
            </Typography>
            <Typography variant="h2" className="testimonial-title">
              TOP CLIENTS REVIEWS
            </Typography>
          </Box>

          {/* Testimonial content wrapper */}
          <Box className="testimonial-wrapper">
            {/* Previous navigation button */}
            <IconButton
              onClick={handlePrevious}
              className="nav-button nav-button-prev"
              size={isMobile ? "medium" : "large"}
            >
              <ArrowBack />
            </IconButton>

            {/* Testimonial card with fade animation */}
            <Fade in={true} key={currentIndex} timeout={500}>
              <Box className="card-container">
                <Box className="testimonial-card">
                  {/* Top-left dot pattern decoration */}
                  <Box className="dot-pattern dot-pattern-top-left">
                    {[...Array(25)].map((_, i) => (
                      <Box key={i} className="dot" />
                    ))}
                  </Box>

                  {/* Bottom-right dot pattern decoration */}
                  <Box className="dot-pattern dot-pattern-bottom-right">
                    {[...Array(25)].map((_, i) => (
                      <Box key={i} className="dot" />
                    ))}
                  </Box>

                  {/* Quote icon */}
                  <Box className="quote-icon-container">
                    <img src={websiteImages.quoteIconImage}></img>
                  </Box>

                  {/* Testimonial text */}
                  <Typography variant="body1" className="testimonial-text">
                    {currentTestimonial.text}
                  </Typography>

                  {/* Author information */}
                  <Box className="author-container">
                    <Avatar
                      src={currentTestimonial.avatar}
                      alt={currentTestimonial.name}
                      className="author-avatar"
                    />
                    <Typography variant="h6" className="author-name">
                      {currentTestimonial.name}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Fade>

            {/* Next navigation button */}
            <IconButton
              onClick={handleNext}
              className="nav-button nav-button-next"
              size={isMobile ? "medium" : "large"}
            >
              <ArrowForward />
            </IconButton>
          </Box>
        </div>
      </Box>
    </div>
  );
};

// Export the Testimonial component
export default Testimonial;